define('controllers/admin/galileo',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        var grid = CreateJohnGrid(),
               columns = [{ DataField: "ErrorInformation" },
                           { DataField: "GalileoCode" },
                           { DataField: "GalileoSeverity" },
                           { DataField: "GalileoMessage" },
                           { DataField: "OurMessage" },
                           { DataField: "CreateDate" }],
               chkNoMessage = $("#chkNoMessage"),
               txtOurMessage = $("input[name='OurMessage']");

        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";

        grid.editHelpers.init($("#editGalileoError"));
        grid.editHelpers.onEdit = function (item) {
            item.OurMessage == "&nbsp;" ? chkNoMessage.prop('checked', true) : chkNoMessage.prop('checked', false);
            setNoMessageCheckbox();
        };
        setNoMessageCheckbox();
        chkNoMessage.on("change", setNoMessageCheckbox);
        function setNoMessageCheckbox() {
            var ourmessage = $("#ourMessageLabel, input[name='OurMessage']");
            chkNoMessage.is(':checked') ? ourmessage.hide() : ourmessage.show();
            setUpPreview();
        }

        txtOurMessage.on("keyup", setUpPreview);

        function setUpPreview() {
            var message = "The hotel reported that no rooms are available for the specified date range and number of people.",
                ourMessage = txtOurMessage.val().trim(),
                galileoMessage = $("[data-name='GalileoMessage']").html(),
                finalMessage = "<br /><br />Information From Hotel: " + (ourMessage == "" ? galileoMessage : ourMessage);

            message += chkNoMessage.is(':checked') ? "" : finalMessage;
            $("#preview").html(message);
        }

        grid.init($("#galileoErrors"), columns, "galileoErrorsAJAX.aspx");
        grid.databind();
    };
});

